import clsx from 'clsx';
import Card from 'components/atoms/Card/Card';
import Txt from 'components/atoms/Txt/Txt';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { ReactElement } from 'react';
import { useFinishedSurveyCardFragmentQuery_surveyRef$key } from './__generated__/useFinishedSurveyCardFragmentQuery_surveyRef.graphql';
import classes from './FinishedSurveyCard.qmee.module.scss';
import { useFinishedSurveyCardFragmentQuery } from './useFinishedSurveyCardFragmentQuery';

dayjs.extend(localizedFormat);

export type Props = {
  className?: string;
  surveyRef: useFinishedSurveyCardFragmentQuery_surveyRef$key;
};

export default function FinishedSurveyCard({ className, surveyRef }: Props): ReactElement {
  const survey = useFinishedSurveyCardFragmentQuery(surveyRef);
  const statusClass = classes[`status_${survey.status.toLowerCase()}`];
  const displayId = survey.studyId?.substring(0, 8);

  return (
    <Card className={clsx(classes.root, className)}>
      <div className={classes.body}>
        <div className={classes.titleRow}>
          <Txt className={classes.title}>{survey.title}</Txt>
          {survey.startedAt && (
            <Txt component="span" className={classes.startedAt} skipTranslation>
              {dayjs(survey.startedAt).format('L LT')}
            </Txt>
          )}
        </div>
        <div className={classes.metaRow}>
          {displayId && (
            <Txt component="span" className={classes.id} skipTranslation>
              {`#${displayId}`}
            </Txt>
          )}
        </div>
        <Txt component="p" className={clsx(classes.status, statusClass)} skipTranslation>
          {survey.statusDescription}
        </Txt>
      </div>
    </Card>
  );
}
